import { isNewPlan } from "../../shared/utils";
import AbstractSettingsTool from "../AbstractSettingsTool";

export default class SettingsTool extends AbstractSettingsTool {
    constructor(provider) {
        super(provider);
    }

    addOptions() {
        this.settingsMenu.addContent(this.createNameInput());
        this.settingsMenu.addContent(this.createCheckboxes());
        this.settingsMenu.addContent(this.createUnitOption());
        this.settingsMenu.addContent(this.createAccessOption());
        if (!isNewPlan(this.p)) {
            this.settingsMenu.addContent(this.createDeleteOption());
        }
    }

    createCheckboxes() {
        let container = this.p.createDiv().class('input-group -has-checkbox');
        this.createGridOption(container);
        this.createSnapToGridOption(container);
        this.createLabelOption(container);
        this.createLockLabelsOption(container);
        this.createShowImageOption(container);
        return container;
    }

    createSnapToGridOption(container) {
        this.settings.snapToGridCheckbox = this.p.createCheckbox('Snap to grid', true)
            .parent(container);
        this.settings.snapToGridCheckbox.elt.firstChild.firstChild.id = 'snap-to-grid';
    }

    createLockLabelsOption(container) {
        this.settings.lockLabelsCheckbox = this.p.createCheckbox('Lock labels', true)
            .parent(container);
        this.settings.lockLabelsCheckbox.elt.firstChild.firstChild.id = 'lock-labels';
    }

    createNameInput() {
        let container = this.p.createDiv().class('input-group');
        let label = this.p.createDiv('Name:')
            .parent(container)
            .class('input-label');
        this.settings.nameInput = this.p.createInput(this.planName)
            .parent(container)
            .id('plan-name')
            .class('input-text');
        this.settings.nameInput.elt.onchange = () => this.changesMade();
        return container
    }

    createAccessOption() {
        let accessWrapper = this.p.createDiv().class('input-group input-select-wrapper');
        let accessLabel = this.p.createDiv('Access:')
            .parent(accessWrapper)
            .class('input-label');
        this.settings.accessSelector = this.p.createSelect()
            .parent(accessWrapper)
            .class('input-select')
            .id('plan-access');
        this.settings.accessSelector.elt.addEventListener('change', () => this.changesMade());
        this.settings.accessSelector.option('Public', 'public');
        this.settings.accessSelector.option('With link', 'link');
        this.settings.accessSelector.option('Private', 'private');
        return accessWrapper;
    }

    createDeleteOption() {
        let deleteOption = this.p.createDiv()
            .class('input-group')
            .style('background', '#ffdddd')
            .style('border-radius', '5px')
            .style('padding', '5px');
        let label = this.p.createDiv('Write the name of the plan to delete it:')
            .class('input-label')
            .parent(deleteOption);
        let input = this.p.createInput('')
            .parent(deleteOption)
            .class('input-text')
            .id('delete-plan-input')
            .input(() => {
                input.value() == this.settings.name
                    ? deleteButton.removeAttribute('disabled')
                    : deleteButton.attribute('disabled', true);
            });
        let deleteButton = this.p.createButton('Delete plan')
            .parent(deleteOption)
            .class('btn-danger')
            .attribute('disabled', true)
            .mouseClicked(() => this.deletePlan());
        return deleteOption;
    }

    deletePlan() {
        this.dataHandler.deletePlan();
    }
}
